'use strict';

angular.module('mean.system').controller('HeaderController', ['$scope', '$rootScope', 'Menus', 'MeanUser', '$state', '$location', '$window',
  function ($scope, $rootScope, Menus, MeanUser, $state, $location, $window) {
    var vm = this;

    vm.menus = {};
    vm.hdrvars = {
      authenticated: MeanUser.loggedin,
      user: MeanUser.user,
      isAdmin: MeanUser.isAdmin
    };

    // Default hard coded menu items for main menu
    var defaultMainMenu = [];

    // Query menus added by modules. Only returns menus that user is allowed to see.
    function queryMenu (name, defaultMenu) {
      Menus.query({
        name: name,
        defaultMenu: defaultMenu
      }, function (menu) {
        vm.menus[name] = menu
      });
    }
// console.log('in the HeaderController');
//     tidioChatApi.setVisitorData({
//       user: MeanUser.user.username,
//       name: MeanUser.user.name,
//       email: MeanUser.user.email,
//     });

    // Query server for menus and check permissions
    queryMenu('main', defaultMainMenu);
    queryMenu('account', []);

    $scope.isCollapsed = false;

    $rootScope.$on('loggedin', function () {
      queryMenu('main', defaultMainMenu);

      vm.hdrvars = {
        authenticated: MeanUser.loggedin,
        user: MeanUser.user,
        isAdmin: MeanUser.isAdmin
      }

      //$window.user_role = MeanUser.user.roles[0];
    });

    vm.logout = function () {
      MeanUser.logout()
    };

    $rootScope.$on('logout', function () {
      vm.hdrvars = {
        authenticated: false,
        user: {},
        isAdmin: false
      };
      $window.user_role = '';
      $window.pts_username = null;
      queryMenu('main', defaultMainMenu);
      $state.go('home');
    });
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/controllers/header.js